import { Box, Button, Stack, Typography } from '@mui/material';
import { exportFileTypes } from '../models/exportFileTypes';

export const ExportErrorFeedback = ({
  status,
  message,
  onExportCsv,
  onClose,
  recommendedFormat = 'excel',
}: {
  status?: number;
  message?: string;
  onExportCsv?: () => void;
  onClose?: () => void;
  recommendedFormat: exportFileTypes;
}) => {
  if (status === 416) {
    return (
      <Box sx={{ mt: 3 }}>
        <Stack direction="column" spacing={2}>
          <Typography sx={{ fontSize: 12 }}>
            The requested format may take a long time to generate. <br />
            <b>Tip :</b> Try the {recommendedFormat} format for a faster download.
          </Typography>
          {onExportCsv && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                onClose?.();
                onExportCsv();
              }}
            >
              Export CSV Format
            </Button>
          )}
        </Stack>
      </Box>
    );
  }
  return <Typography>{message ?? 'Error exporting report'}</Typography>;
};
